module.exports = "https://coursera_assets.s3.amazonaws.com/images/98ba90a5f711f0ac758b336f104cef48.png";